import React, { useState } from "react";
import axios from "axios";
import "./ShareMemory.css";

function ShareMemory() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    department: "",
    message: "",
  });

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setSelectedFiles([...e.target.files]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("name", formData.name);
    data.append("department", formData.department);
    data.append("message", formData.message);

    selectedFiles.forEach((file, index) => {
      data.append(`files[]`, file); // Appending multiple files
    });

    //axios.post("http://localhost/reunion1994/uploadimage.php", data, {
    axios.post("https://acr.iitm.ac.in/reunion1994/uploadimage.php", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        alert("Memories shared successfully!");
        setSelectedFiles([]);
        setFormData({
          name: "",
          department: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("There was an error uploading the images!", error);
      });
  };

  return (
    <>
      <section className="share-memory-container" id="sharingmemories">
        <div className="container">
          <div className="row">
            <div className="col d-flex sharememo" style={{ gap: "20px", justifyContent: "center" }}>
              <h2 className="sharememowith">We request you to share your memories with us</h2>
              <button className="share-memory-btn" onClick={togglePopup}>
                Share Memories
              </button>
              {isPopupOpen && (
                <div className="popup">
                  <div className="popup-inner popup-container">
                    <button className="close-btn" onClick={togglePopup}>
                      X
                    </button>
                    <div className="popup-body">
                      <div className="container">
                        <div className="row">
                          <div className="col login-box">
                            <h2 className="sharemem">Share Memories and Message with your Batchmates</h2>
                            <form onSubmit={handleSubmit}>
                              <div className="user-box">
                                <input
                                  type="text"
                                  name="name"
                                  required
                                  value={formData.name}
                                  onChange={handleInputChange}
                                />
                                <label>Name</label>
                              </div>
                              <div className="user-box">
                                <input
                                  type="text"
                                  name="department"
                                  required
                                  value={formData.department}
                                  onChange={handleInputChange}
                                />
                                <label>Department</label>
                              </div>
                              <div className="upload-btn-wrapper">
                                <label>Show us how amazing it was (max 1mb each)</label>
                                <button className="addphoto-btn" type="button">
                                  Add Photos<span style={{ color: "green", fontSize: "20px" }}> +</span><br/>
                                  {selectedFiles.length > 0 && (
                                    <span style={{ color: "green", fontSize: "16px" }}>{selectedFiles.length} Image(s) Selected</span>
                                  )}
                                </button>
                                <input
                                  type="file"
                                  name="files"
                                  multiple
                                  onChange={handleFileChange}
                                />
                              </div>
                              <div className="user-box">
                                <textarea
                                  name="message"
                                  required
                                  value={formData.message}
                                  onChange={handleInputChange}
                                />
                                <label>Your message to your batchmates (max 100 words)</label>
                              </div>
                              <button type="submit" className="submit-btn">Submit</button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ShareMemory;
